import { useEffect, useMemo, useState } from "react";

/**
 * Paging for small lists that are already fully loaded (settings versions,
 * reconciliation previews, …) — same Pager as the server-paged pages.
 * Usage: const { pageItems, pagerProps } = useClientPaging(rows); …
 *        <Pager {...pagerProps} />
 */
export default function useClientPaging<T>(items: T[], initialLimit = 25) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(initialLimit);

  // Back to page 1 when the list (e.g. a filter) or the page size changes
  useEffect(() => { setPage(1); }, [items, limit]);

  const pageItems = useMemo(() => items.slice((page - 1) * limit, page * limit), [items, page, limit]);

  return {
    pageItems,
    pagerProps: { page, limit, total: items.length, onPage: setPage, onLimit: setLimit },
  };
}
